/**
 * 메일 발송 폼 모달 컴포넌트.
 *
 * 사용법:
 *   1) 페이지에 fragments/mail-form-modal.html 을 include
 *        <div th:replace="~{fragments/mail-form-modal :: modal}"></div>
 *   2) 트리거에서 이벤트 dispatch (선택 인자: to / subject / body)
 *        $dispatch('open-mail-form', { to: '', subject: '', body: '' })
 *
 * 본문은 plain text 로만 발송 (백엔드 MailService.sendPlain).
 */
export default () => ({
    open: false,
    loading: false,
    to: '',
    subject: '',
    body: '',

    openModal(detail) {
        this.to = (detail && detail.to) || '';
        this.subject = (detail && detail.subject) || '';
        this.body = (detail && detail.body) || '';
        this.open = true;
        this.$nextTick(() => {
            if (!this.to) this.$refs.toInput?.focus();
            else if (!this.subject) this.$refs.subjectInput?.focus();
            else this.$refs.bodyInput?.focus();
        });
    },

    close() {
        if (this.loading) return;
        this.open = false;
    },

    async submit() {
        if (this.loading) return;
        const to = this.to.trim();
        const subject = this.subject.trim();
        const body = this.body;

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(to)) {
            this.$dispatch('show-toast', { type: 'warning', title: '입력 오류', message: '수신자 이메일 형식이 올바르지 않습니다.' });
            this.$refs.toInput?.focus();
            return;
        }
        if (!subject) {
            this.$dispatch('show-toast', { type: 'warning', title: '입력 오류', message: '제목을 입력해 주세요.' });
            this.$refs.subjectInput?.focus();
            return;
        }
        if (!body.trim()) {
            this.$dispatch('show-toast', { type: 'warning', title: '입력 오류', message: '본문을 입력해 주세요.' });
            this.$refs.bodyInput?.focus();
            return;
        }

        this.loading = true;
        try {
            const res = await fetch('/mail/api/send', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ to, subject, body })
            });
            const data = await res.json();
            if (data.success) {
                this.$dispatch('show-toast', { type: 'success', title: '발송 요청', message: data.message });
                this.open = false;
                this.to = '';
                this.subject = '';
                this.body = '';
            } else {
                this.$dispatch('show-toast', { type: 'error', title: '발송 실패', message: data.message || '메일 발송에 실패했습니다.' });
            }
        } catch (e) {
            this.$dispatch('show-toast', { type: 'error', title: '오류', message: '요청 중 오류가 발생했습니다.' });
        } finally {
            this.loading = false;
        }
    }
});
